import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player/youtube'
import UtilsBufer from '../Tools/UtilsBufer';
import MsgUtils from '../Tools/MsgUtils';
import CircleLoader from "react-spinners/CircleLoader";
const server = process.env.REACT_APP_SERVER;

function DetalleNoticia(props) {
    const { info,regional } = props;
    const [links, setLinks] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    const [loading,setLoading]=useState(true);
    useEffect(() => {
        fetch(`${server}/redSocial/getMensajeLinks`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regional,
                idNoticia: info.ID_NOTICIA,
                tipo:'D'
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setLoading(false);
                if (data.ok) {
                    setLinks(data.ok.links);
                    setImagenes(data.ok.imagenes);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }, [])
    return (
        <div className='container-fluid text-light'>
            <div className='text-center mx-auto'>
                <CircleLoader className='text-center mx-auto' color='#F95E10' loading={loading} size={200} />
            </div>
            {loading===false&&<div className='row row-cols-1 row-cols-md-2 g-0'>
                <div className='col col-sm-12 col-md-12'>
                    <div className='overflow-auto configOverFlow'>
                        <div className='text-center fw-bold fs-4'>{info.TITULO}</div>
                        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner text-center">
                                <div className="carousel-item active">
                                    <img src={`${server}/imagenes/${info.NOMBRE_IMG}`} className='img-fluid'></img>
                                </div>
                                {imagenes.map((item) => {
                                    return (
                                        <div className="carousel-item" key={item.ID_IMAGEN}>
                                            <img src={`${server}/imagenes/${item.NOMBRE_IMG}`} className='img-fluid'></img>
                                        </div>
                                    )
                                })}
                            </div>
                            {imagenes.length!==0&&
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>}
                            {imagenes.length!==0&&
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>}
                        </div>
                        {info.DESCRIPCION != null &&
                            <div className='container-fluid'>
                                <textarea className="form-control bg-dark bg-gradient text-light" value={UtilsBufer.getText(info.DESCRIPCION)}
                                readOnly={true}
                                style={{ height: "220px" }}
                                ></textarea>
                            </div>
                        }
                        <div className='container-fluid'>
                            {links.map((item) => {
                                if (item.TIPO === 'V') {
                                    return (
                                        <div className='text-center py-5' key={item.ID_LINK}>
                                            <div className='text-center fs-4 fw-bold'>{item.DESCRIPCION}</div>
                                            <ReactPlayer url={item.URL} width='100%' />
                                        </div>
                                    )
                                }
                            })}
                        </div>
                        <div className='container-fluid'>
                            {links.filter(item => item.TIPO === 'L').length !== 0 && <div className='text-center fs-4'>Enlaces Externos</div>}
                            {links.map((item) => {
                                if (item.TIPO === 'L')
                                    return (
                                        <div className='py-1 text-center' key={item.ID_LINK}>
                                            <a className='btn btn-dark bg-gradient btn-sm w-50' href={item.URL} target="_blank">
                                                {item.DESCRIPCION}
                                            </a>
                                        </div>
                                    )
                            })}
                        </div>
                    </div>
                </div>
                <div className='col col-sm-12 col-md-2 py-md-4 d-none'>
                    <div className='container-fluid text-center'>
                        COMENTARIOS
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default DetalleNoticia
